import { DailyMoversPayload, HistoryPoint, LeaderboardSnapshot } from "../types/leaderboard";
import { fetchApi } from "./services";

export const fetchLeaderboard = async (): Promise<LeaderboardSnapshot | undefined> =>
  (await fetchApi<LeaderboardSnapshot>("leaderboard")) ?? undefined;

export const fetchLeaderboardHistory = async (limit = 100): Promise<HistoryPoint[]> =>
  (await fetchApi<HistoryPoint[]>(`leaderboard/history?limit=${String(limit)}`)) ?? [];

export const fetchLeaderboardMovers = async (params: {
  period?: "daily" | "weekly";
  day?: string | null;
  week?: string | null;
  limit?: number;
}): Promise<DailyMoversPayload | undefined> => {
  const search = new URLSearchParams();
  if (params.period) search.set("period", params.period);
  if (params.day) search.set("day", params.day);
  if (params.week) search.set("week", params.week);
  if (params.limit) search.set("limit", String(params.limit));
  const query = search.toString();
  return (
    (await fetchApi<DailyMoversPayload>(
      query ? `leaderboard/movers?${query}` : "leaderboard/movers",
    )) ?? undefined
  );
};
